import moment from "moment";

/** Четыре поля формы подтверждения документа. */
export type DocumentFormValues = {
  first_name?: string;
  last_name?: string;
  document_number?: string;
  birth_date?: string;
};

/** То, что вернуло распознавание. null — не распозналось. */
export type ParsedDocument = {
  original_first_name?: string | null;
  original_last_name?: string | null;
} | null;

export type DocumentInfo = {
  document_number?: string;
  first_name?: string;
  last_name?: string;
  original_first_name?: string;
  original_last_name?: string;
  birth_date: string | null;
};

/**
 * Дата рождения к виду YYYY-MM-DD.
 *
 * Клиент вводит руками в DD.MM.YYYY, распознавание отдаёт YYYY-MM-DD. Что не
 * разобралось ни так, ни так — null: бэкенд лучше примет пустую дату, чем
 * строку в чужом формате.
 */
export function normalizeBirthDate(input?: string): string | null {
  for (const format of ["DD.MM.YYYY", "YYYY-MM-DD"]) {
    const parsed = moment(input, format, true);
    if (parsed.isValid()) return parsed.format("YYYY-MM-DD");
  }
  return null;
}

/**
 * `document_info` для отправки документа.
 *
 * Источник истины — форма, а распознавание лишь подставляет в неё значения и
 * хранит оригинальное написание имени. Раньше объект собирался ТОЛЬКО когда
 * распознавание сработало: клиент с нераспознанным документом заполнял поля
 * руками, а они молча выбрасывались — на бэкенд не уходило ничего, и анкета
 * застревала на шаге документов (клиент 16747, 05.10.2026).
 */
export function buildDocumentInfo(
  values: DocumentFormValues,
  parsedData: ParsedDocument,
): DocumentInfo {
  return {
    document_number: values?.document_number,
    first_name: values?.first_name,
    last_name: values?.last_name,
    original_first_name:
      parsedData?.original_first_name || values?.first_name,
    original_last_name: parsedData?.original_last_name || values?.last_name,
    birth_date: normalizeBirthDate(values?.birth_date),
  };
}
